import { useForm, useMutation } from '@meteor/data-hooks';
import { Button, Spacer, Switch } from '@meteor/ui';
import { authConfigState } from '../state';

export let AuthConfigPage = () => {
  let authConfig = authConfigState.use();
  let update = useMutation(authConfig.mutators.update);

  let form = useForm({
    initialValues: {
      hasWhitelist: !!authConfig.data?.hasWhitelist
    },
    updateInitialValues: true,
    schema: yup =>
      yup.object({
        hasWhitelist: yup.boolean()
      }),
    onSubmit: async values => {
      await update.mutate({
        hasWhitelist: !!values.hasWhitelist
      });
    }
  });

  return (
    <form onSubmit={form.handleSubmit}>
      <Switch
        label="Has Whitelist"
        checked={form.values.hasWhitelist}
        onCheckedChange={v => form.setFieldValue('hasWhitelist', v)}
      />

      <Spacer size={15} />

      <Button type="submit" loading={update.isLoading} success={update.isSuccess}>
        Save
      </Button>
    </form>
  );
};
